import React from "react";

const ProcessingBar = () => {
  return (
    <>
      <span className="loader" />
      <style>{`
        .loader {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          display: block;
          margin: 10px auto;
          position: relative;
          animation: shadowPulse 1s linear infinite;
        }

        @keyframes shadowPulse {
          33% {
            background: #FFF;
            box-shadow: -24px 0 #ca7100, 24px 0 #FFF;
          }
          66% {
            background: #ca7100;
            box-shadow: -24px 0 #FFF, 24px 0 #FFF;
          }
          100% {
            background: #FFF;
            box-shadow: -24px 0 #FFF, 24px 0 #ca7100;
          }
        }
      `}</style>
    </>
  );
};

export default ProcessingBar;
